import { render } from "./AddFortigate.vue?vue&type=template&id=13ab98b6"
import script from "./AddFortigate.vue?vue&type=script&lang=js"
export * from "./AddFortigate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__